import { KeyboardBackspace } from '@mui/icons-material'
import { Box, IconButton, InputBase } from '@mui/material'
import { useHistory, useLocation } from 'react-router-dom';
import { SearchIcons } from '../../../../../core/global/Icons';
import { useContext, useEffect, useState } from 'react';
import { Bulletin, Publication } from './SaveItem';
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader'
import { env } from '../../../../../core/Env';
import { rqx } from '../../../../../core/request/API';
import { ToolContext } from '../../../../../core/context/ToolContext';
import { FeatureIdState } from '../../../toolUsage/global/GlobalFcn';
import { CreateFeatureLogs } from "../../../../../core/global/API";

export const SaveList = () => {
    const { tool_state } = useContext(ToolContext)
    const { __SESSION } = tool_state

    const [search, setSearch] = useState('')
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [isLoader, setIsLoader] = useState(false)
    const [savePublication, setSavePublication] = useState([])
    const [saveBulletin, setsaveBulletin] = useState([])

    const location = useLocation();
    const history = useHistory();
    const tab = [{ id: 1, path: 'news' },{ id: 2, path: 'updates' },{ id: 3, path: 'article' },];
    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8)
    const initialType = tab.find((v) => v.path === location.pathname.split('/')[3])
    
    const changeHandler = (e) => {
        setSearch(e.target.value)
    }

    const viewHandler = (id) => {
        const encodeId = btoa(id).replace(/=+$/, '')

        if (location.pathname.split("/")[3] === 'bulletin') {
            history.push(`/psl/bulletin/${encodeId}`)
        } else {
            history.push(`/psl/publication/${location.pathname.split("/")[3]}/${encodeId}`)
        }
    }

    const unsavePublicationHandler = async(save_id, publication_id) => { 
        let data = await rqx.post(`<<tool>>/${env()}/psl/save/saved`, {user_id: user_id, publication_id: publication_id, id: save_id})
        if (data.message === 'success') {
            let d = savePublication.filter((v) => v.id !== publication_id)
            let reqBody = {
                aid: __SESSION.data.ainfo.aid,
                path: `${FeatureIdState('save')}`,
                feature_id: FeatureIdState('save'),
                feature_name: 'save',
                tid: process.env.REACT_APP_TID_PSL,
                company_id: 0,
                action: 3
            }
            await CreateFeatureLogs(reqBody)
            setSavePublication(d);

        }
    }
    
    const getPublicationSave = async (val) => { 
        if (val === 0) {
            setIsLoader(true)
        }
        if (location.pathname.split('/')[3] === 'bulletin') {
            const data = await rqx.get(`<<tool>>/${env()}/psl/save/savedBulletin`, {user_id: user_id})             
            setsaveBulletin(data)
            setIsLoader(false);
        } else {
            const data = await rqx.get(`<<tool>>/${env()}/psl/save/readSaved`, {user_id: user_id, type: initialType.id})             
            if (data.length > 0) {
                const userInfo = await rqx.get(`<<global>>/${env()}/primeinfo/read`, { aid: window.btoa(`tool_${data[0].created_by}`) });
                const enrichedData = data.map(item => ({
                    ...item,
                    ...(userInfo.length > 0 ? userInfo[0] : {})
                }));            
                setSavePublication(enrichedData)
                setIsLoader(false);
            } else {
                setSavePublication([])
                setIsLoader(false);
            }   
            
        }
    }
    
    useEffect(() => {
        getPublicationSave(0)

        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 400);

        return () => {
            clearTimeout(handler);
        };

         // eslint-disable-next-line
    }, [search])

    useEffect(() => {
        const getSearch = async () => {
            if (debouncedSearch.trim() === '') return getPublicationSave(0)
            try {
                setIsLoader(true);
                let data = await rqx.get(`<<tool>>/${env()}/psl/save/searchSave`, {
                    type: initialType.id,
                    user_id: user_id,
                    search: debouncedSearch
                });
                setSavePublication(data)
            } catch (error) {
                console.error("Search error:", error);
            } finally {
                setIsLoader(false);
            }
        };
        if (location.pathname.split('/')[3] !== 'bulletin') return getSearch()
        
         // eslint-disable-next-line
    }, [debouncedSearch]);

    return (
        <Box bgcolor="#FFFFFF" >
            <Box bgcolor="#FFFFFF"  position="sticky" top={0} zIndex={3}>
                <Box display="flex" justifyContent="space-between" alignItems="center" p="8px 16px" position="sticky" top="0px" zIndex={3}>
                    <IconButton onClick={() => history.goBack()}> <KeyboardBackspace/></IconButton>
                    <Box fontSize="12px" fontWeight="600">SAVED</Box>
                    <Box sx={{ width: 40 }} />
                </Box>
                <Box display="flex" flexDirection="column" gap="24px" p="24px 16px 12px 16px">
                    <Box fontSize="28px" fontWeight="700" color="#292C2F" lineHeight="140%">
                        {location.pathname.split("/")[3].charAt(0).toUpperCase() + location.pathname.split("/")[3].slice(1).toLowerCase()}
                    </Box>
                    <Box display={location.pathname.split("/")[3] === "bulletin" ? "none" : "flex"} alignItems="center" gap="12px" bgcolor="#F7F8F8" borderRadius="6px" p="8px 12px">
                        <SearchIcons/>
                        <InputBase
                            value={search}
                            onChange={(e) => changeHandler(e)}
                            sx={{ width: '100%' }}
                            placeholder="Search by title, topic or author"
                            inputProps={{ 'aria-label': 'Search by title, topic or author' }}
                        />
                    </Box>
                </Box>
            </Box>
            {isLoader ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="50px">
                    <SnakeLoader size="0.7rem" bg="#453FBA" distance="0.2rem" />
                </Box>
            ) : (
                location.pathname.split("/")[3] === "bulletin" ? (
                    saveBulletin.length > 0 ?
                        saveBulletin.map((v, i) => (
                            <Bulletin key={i} v={v} location={location} viewHandler={viewHandler} />
                        ))
                    :
                        <Box pt="40px" display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap="4px">
                            <Box fontSize="14px" fontWeight="600">No saved records found</Box>
                            <Box fontSize="12px" color="#8F969D">Stories you've saved will appear here.</Box>
                        </Box>
                ) : (
                    savePublication.length > 0 ?
                        savePublication.map((v, i) => (
                            <Publication 
                                key={i} 
                                v={v} 
                                location={location} 
                                viewHandler={viewHandler} 
                                unsavePublicationHandler={unsavePublicationHandler}
                            />
                        ))
                    :
                        <Box pt="24px" display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap="4px">
                            <Box fontSize="14px" fontWeight="600">No saved records found</Box>
                            <Box fontSize="12px" color="#8F969D">Stories you've saved will appear here.</Box>
                        </Box>
                )
            )}
        </Box>
    )
}
